unit View.Grade_Linhas.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewGrade_LinhasList = class(TForm)
    btNew: TButton;
    Grade_LinhasDataset: TXDataWebDataSet;
    Grade_LinhasDatasetid: TIntegerField;
    Grade_LinhasDatasetaliado_id: TIntegerField;
    Grade_LinhasDatasetdata_base_id: TIntegerField;
    Grade_LinhasDatasetgrade_descricoes_id: TIntegerField;
    Grade_LinhasDatasetnome: TStringField;
    Grade_LinhasDatasetcadastro: TDateTimeField;
    Grade_LinhasDatasetcodigo_interno: TIntegerField;
    Grade_LinhasDatasetexcluido: TBooleanField;
    Grade_LinhasDatasetinclusao: TDateTimeField;
    Grade_LinhasDatasetalteracao: TDateTimeField;
    Grade_LinhasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_LinhasList: TFViewGrade_LinhasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_LinhasList }

procedure TFViewGrade_LinhasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewGrade_LinhasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_LinhasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewGrade_LinhasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_LinhasList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewGrade_LinhasList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewGrade_LinhasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Grade_LinhasDataset.Connection.Model.DefaultSchema.FindEntityType(Grade_LinhasDataset.EntitySetName),
      Grade_LinhasDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewGrade_LinhasList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('grade_linhas', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');
  TUtils.SetValorDicionarioClasses('grades_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_grades', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Grade_LinhasDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewGrade_LinhasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.grade_linhas.list.pagination.info');
  btNew := TButton.Create('view.grade_linhas.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.grade_linhas.list.table');
  cbPageSize := TComboBox.Create('view.grade_linhas.list.cbPageSize');
  edSearch := TEdit.Create('view.grade_linhas.list.search');
  lcPaginator := TListControl.Create('view.grade_linhas.list.pagination');
  Grade_LinhasDataset := TXDataWebDataSet.Create(Self);
  Grade_LinhasDatasetid := TIntegerField.Create(Self);
  Grade_LinhasDatasetaliado_id := TIntegerField.Create(Self);
  Grade_LinhasDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_LinhasDatasetgrade_descricoes_id := TIntegerField.Create(Self);
  Grade_LinhasDatasetnome := TStringField.Create(Self);
  Grade_LinhasDatasetcadastro := TDateTimeField.Create(Self);
  Grade_LinhasDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_LinhasDatasetexcluido := TBooleanField.Create(Self);
  Grade_LinhasDatasetinclusao := TDateTimeField.Create(Self);
  Grade_LinhasDatasetalteracao := TDateTimeField.Create(Self);
  Grade_LinhasDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Grade_LinhasDataset.BeforeLoadDFMValues;
  Grade_LinhasDatasetid.BeforeLoadDFMValues;
  Grade_LinhasDatasetaliado_id.BeforeLoadDFMValues;
  Grade_LinhasDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_LinhasDatasetgrade_descricoes_id.BeforeLoadDFMValues;
  Grade_LinhasDatasetnome.BeforeLoadDFMValues;
  Grade_LinhasDatasetcadastro.BeforeLoadDFMValues;
  Grade_LinhasDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_LinhasDatasetexcluido.BeforeLoadDFMValues;
  Grade_LinhasDatasetinclusao.BeforeLoadDFMValues;
  Grade_LinhasDatasetalteracao.BeforeLoadDFMValues;
  Grade_LinhasDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_LinhasList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_descricoes_id';
      Title := 'grade_descricoes_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cadastro';
      Title := 'cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Grade_LinhasDataset.SetParentComponent(Self);
    Grade_LinhasDataset.Name := 'Grade_LinhasDataset';
    Grade_LinhasDataset.EntitySetName := 'Grade_Linhas';
    Grade_LinhasDataset.Connection := DMConnection.ApiConnection;
    Grade_LinhasDataset.Left := 72;
    Grade_LinhasDataset.Top := 144;
    Grade_LinhasDatasetid.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetid.Name := 'Grade_LinhasDatasetid';
    Grade_LinhasDatasetid.FieldName := 'id';
    Grade_LinhasDatasetid.Required := True;
    Grade_LinhasDatasetaliado_id.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetaliado_id.Name := 'Grade_LinhasDatasetaliado_id';
    Grade_LinhasDatasetaliado_id.FieldName := 'aliado_id';
    Grade_LinhasDatasetaliado_id.Required := True;
    Grade_LinhasDatasetdata_base_id.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetdata_base_id.Name := 'Grade_LinhasDatasetdata_base_id';
    Grade_LinhasDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_LinhasDatasetdata_base_id.Required := True;
    Grade_LinhasDatasetgrade_descricoes_id.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetgrade_descricoes_id.Name := 'Grade_LinhasDatasetgrade_descricoes_id';
    Grade_LinhasDatasetgrade_descricoes_id.FieldName := 'grade_descricoes_id';
    Grade_LinhasDatasetgrade_descricoes_id.Required := True;
    Grade_LinhasDatasetnome.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetnome.Name := 'Grade_LinhasDatasetnome';
    Grade_LinhasDatasetnome.FieldName := 'nome';
    Grade_LinhasDatasetnome.Required := True;
    Grade_LinhasDatasetnome.Size := 255;
    Grade_LinhasDatasetcadastro.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetcadastro.Name := 'Grade_LinhasDatasetcadastro';
    Grade_LinhasDatasetcadastro.FieldName := 'cadastro';
    Grade_LinhasDatasetcodigo_interno.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetcodigo_interno.Name := 'Grade_LinhasDatasetcodigo_interno';
    Grade_LinhasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_LinhasDatasetcodigo_interno.Required := True;
    Grade_LinhasDatasetexcluido.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetexcluido.Name := 'Grade_LinhasDatasetexcluido';
    Grade_LinhasDatasetexcluido.FieldName := 'excluido';
    Grade_LinhasDatasetinclusao.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetinclusao.Name := 'Grade_LinhasDatasetinclusao';
    Grade_LinhasDatasetinclusao.FieldName := 'inclusao';
    Grade_LinhasDatasetalteracao.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetalteracao.Name := 'Grade_LinhasDatasetalteracao';
    Grade_LinhasDatasetalteracao.FieldName := 'alteracao';
    Grade_LinhasDatasetexclusao.SetParentComponent(Grade_LinhasDataset);
    Grade_LinhasDatasetexclusao.Name := 'Grade_LinhasDatasetexclusao';
    Grade_LinhasDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Grade_LinhasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Grade_LinhasDataset.AfterLoadDFMValues;
    Grade_LinhasDatasetid.AfterLoadDFMValues;
    Grade_LinhasDatasetaliado_id.AfterLoadDFMValues;
    Grade_LinhasDatasetdata_base_id.AfterLoadDFMValues;
    Grade_LinhasDatasetgrade_descricoes_id.AfterLoadDFMValues;
    Grade_LinhasDatasetnome.AfterLoadDFMValues;
    Grade_LinhasDatasetcadastro.AfterLoadDFMValues;
    Grade_LinhasDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_LinhasDatasetexcluido.AfterLoadDFMValues;
    Grade_LinhasDatasetinclusao.AfterLoadDFMValues;
    Grade_LinhasDatasetalteracao.AfterLoadDFMValues;
    Grade_LinhasDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
